import { useOnboardingNewHomeTakeoverEnabled } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingNewHomeTakeover';
import { useHomeOnboardingTakeoverV2Eligibility } from '@confluence/experiment-home-onboarding-takeover-v2/entry-points/useHomeOnboardingTakeoverV2Eligibility';
import { expVal, expValEquals } from '@confluence/feature-experiments';

export type OnboardingTakeoverType = 'v1' | 'v2';

/**
 * Hook to determine which onboarding takeover will be displayed.
 *
 * @returns The type of onboarding takeover, or `null` if no takeover.
 */
export function useOnboardingTakeoverType(): OnboardingTakeoverType | null {
	const { isEnabled: isV1Enabled, loading: isV1Loading } = useOnboardingNewHomeTakeoverEnabled();

	const v2Eligible = useHomeOnboardingTakeoverV2Eligibility();

	// Calibration event for the v2 experiment
	if (v2Eligible) {
		expVal('cc_home_onboarding_takeover_v2_land_aa', 'cohort', null);
	}

	if (v2Eligible && expValEquals('cc_home_onboarding_takeover_v2_land', 'cohort', 'experiment')) {
		return 'v2';
	}

	if (!isV1Loading && isV1Enabled) {
		return 'v1';
	}

	return null;
}
